import Div100vh from "react-div-100vh"
import styled from "styled-components/macro"
// import { device } from "theme/device"
import { device } from "../../theme/device"

import { OpenToggleButton, CloseToggleButton } from "./Toggle"

export const NavMenuHolder = styled(Div100vh)`
  position: fixed;
  z-index: 9999;
  top: ${({ isopen }) => (isopen ? "0" : "100vh")};
  width: 100vw;
  display: flex;
  align-items: center;
  user-select: none;
  transition: top 0.3s ease;
  background-color: ${({
    theme: {
      palette: { menuBG }
    }
  }) => menuBG};
  color: ${({
    theme: {
      palette: { menuFG }
    }
  }) => menuFG};
`

export const ButtonHolder = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1;
  display: grid;
  grid-template-columns: ${({ role }) =>
    `repeat(${role === "sender" ? "3" : "2"}, 60px)`};
  gap: 10;
`

export const LinkGroup = styled.div`
  width: 100%;
  height: 100%;
  padding-left: 5vw;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const LinkItem = styled.span`
  font-size: 1.5vw;
  line-height: 8vh;
  text-transform: uppercase;
  font-family: NotoSans-Regular;
  letter-spacing: 0.2em;
  color: #361b50;
  @media ${device.laptopL} {
    font-size: 2.5vw;
  }
  @media ${device.laptop} {
    font-size: 3.3vw;
  }
  @media ${device.mobileL} {
    font-size: 1rem;
  }
`

export const OpenToggle = styled(OpenToggleButton)`
  position: fixed;
  bottom: 0;
  width: 16em;
  z-index: 1;
`

export const CloseToggle = styled(CloseToggleButton)`
  position: absolute;
  bottom: 0;
  width: 16em;
  z-index: 9999;
`
